import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Zap, Mail } from 'lucide-react';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function VerifyEmail() {
  const [otp, setOtp]         = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const { loadUser } = useAuth();
  const navigate = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.verifyEmail({ otp });
      await loadUser();
      toast.success('Email verified successfully!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Invalid or expired code');
    } finally { setLoading(false); }
  };

  const resend = async () => {
    setResending(true);
    try {
      await authAPI.resendOtp();
      toast.success('New code sent to your email');
    } catch { toast.error('Failed to resend'); }
    finally { setResending(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign:'center' }}>
        <div style={{ width:60,height:60,borderRadius:'50%',background:'var(--brand-light)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 20px',color:'var(--brand)' }}>
          <Mail size={28}/>
        </div>
        <div className="auth-logo" style={{ justifyContent:'center' }}><Zap size={20} fill="currentColor" style={{display:'inline',marginRight:6}}/>Wispy</div>
        <h1 className="auth-title" style={{ marginTop:8 }}>Check your email</h1>
        <p style={{ color:'var(--text2)',fontSize:14,marginBottom:28 }}>
          We sent a 6-digit verification code to your email address.
        </p>
        <form onSubmit={handle} style={{ display:'flex',flexDirection:'column',gap:16 }}>
          <input className="input" type="text" placeholder="000000" value={otp}
            onChange={e => setOtp(e.target.value.replace(/\D/g,'').slice(0,6))}
            maxLength={6} style={{ fontSize:26,letterSpacing:10,textAlign:'center',paddingLeft:10 }} required/>
          <button className="btn btn-primary btn-lg" type="submit" disabled={loading} style={{width:'100%'}}>
            {loading ? 'Verifying…' : 'Verify email'}
          </button>
        </form>
        <button type="button" className="btn btn-ghost btn-sm" onClick={resend} disabled={resending}
          style={{ marginTop:16,color:'var(--text3)',width:'100%' }}>
          {resending ? 'Sending…' : "Didn't receive a code? Resend"}
        </button>
      </div>
    </div>
  );
}
